module.exports = __webpack_public_path__ + "img/Waaltastisch.39cd0857.svg";